<template>
  <div class="ui-select-btn-group">
    <div class="ui-select-btn">
      <div class="ui-select-btn-label">
        {{ selectedField?.title || "Selecteer een actie" }}
      </div>
      <ui-icon name="chevron-down" />
    </div>
    <v-menu
      activator="parent"
      class="ui-menu kyano-menu"
      :close-on-content-click="false"
      :max-height="400"
      :width="300"
    >
      <div class="ui-card overflow-hidden">
        <div class="pa-2">
          <v-text-field
            v-model="searchQuery"
            placeholder="Zoeken"
            clearable
            hide-details
            density="compact"
            variant="solo"
          />
        </div>
        <v-list class="border-0 border-none" color="var(--primary)">
          <ui-list-item icon="ban" title="Geen" arrow @click="selectField('')" />
          <div v-for="(category, index) in filteredActionTypes" :key="index">
            <ui-list-item :title="category.title" :icon="category.icon" arrow />
            <v-menu
              activator="parent"
              class="ui-menu kyano-menu"
              submenu
              :max-height="400"
              :width="300"
              location="end"
            >
              <v-list elevation="0" density="compact" color="var(--primary)">
                <ui-list-item
                  v-for="(field, i) in category.fields"
                  :key="i"
                  :title="field.title"
                  :icon="field.icon"
                  @click="selectField(field)"
                />
              </v-list>
            </v-menu>
          </div>
        </v-list>
      </div>
    </v-menu>
  </div>
</template>

<script>
  import al from "@/util/Actionslist";

  export default {
    name: "ActionTypes",
    props: {
      modelValue: String,
      fields: Array,
    },
    emits: ["update:modelValue"],
    data() {
      return {
        searchQuery: "",
        selectedField: null,
        actionTypes: al.Actionslist(),
      };
    },
    computed: {
      filteredActionTypes() {
        if (!this.searchQuery) return this.actionTypes;
        return this.actionTypes
          .map((cat) => {
            const filtered = (cat.fields || cat.item).filter((f) =>
              f.title.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
            return { ...cat, fields: filtered };
          })
          .filter((cat) => cat.fields?.length);
      },
    },
    watch: {
      modelValue: {
        handler(value) {
          this.findSelected(value);
        },
        immediate: true,
      },
    },
    methods: {
      findSelected(value) {
        for (const cat of this.actionTypes) {
          const fields = cat.fields || cat.item || [];
          const match = fields.find((f) => f.value === value);
          if (match) {
            this.selectedField = match;
            return;
          }
        }
        this.selectedField = null;
      },
      selectField(field) {
        this.selectedField = field;
        this.$emit("update:modelValue", field.value);
      },
    },
  };
</script>
